/**
 * Renders the footer for a section of the Utah Code, displaying information on when the section was amended.
 * @param {string} ammendedBy - The person or organization that amended the section.
 * @param {string} ammendedSession - The session during which the section was amended.
 * @returns {JSX.Element}
 */
export default function Footer({ ammendedBy, ammendedSession }) {
  return (
    <div className="pl-6 pt-4">
      Amended by {ammendedBy}, {ammendedSession}
    </div>
  );
}
